/**
 * Created by commyfeng on 2017/3/17.
 */

import Coa from '@tencent/Coa/index';
import RequestError from '@tencent/Coa/lib/RequestError';
import RequestErrorType from '@tencent/Coa/lib/RequestErrorType';
var baseUrl = '//activity.video.qq.com/fcgi-bin/asyn_activity?otype=json&type=10&option=1';
var filterRet0 = Coa.filterResponse(function (res) {
  if (res.ret !== 0) {
    try {
      var _window$aegis;
      (_window$aegis = window.aegis) === null || _window$aegis === void 0 ? void 0 : _window$aegis.vWarn({
        tag: 'magicService:markRead请求错误[filterRet0]',
        error: res
      });
    } catch (_) {}
    throw new RequestError(res.ret, res.msg, res, RequestErrorType.SYSTEM_ERR);
  }
  return res;
});
export function markRead(actId) {
  return Coa(Coa.Retry(1), filterRet0).run(baseUrl, {
    act_id: actId
  });
}